import React, { useEffect, useMemo, useState } from "react";
import AdminUserService from "../../../services/adminUserServices";
import { Column, useSortBy, useTable } from "react-table";
import { useForm } from "react-hook-form";
import ButtonWithIcon from "../../../components/StyledComp/ButtonWithIcon";
import ReactModal from "react-modal";
import {
  Button,
  Label,
  PageLink,
} from "../../../components/StyledComp/StyledComp";
import "../../../Styles/CommonStyles.scss";
import EditIcon from "@mui/icons-material/Edit";
import RoundButtonWithIcon from "../../../components/StyledComp/RoundButtonWithIcon";
import LeftArrowIcon from "../../../Images/LeftArrowIcon";
import Pagination from "@mui/material/Pagination";
import { cond } from "lodash";
import { TablePagination } from "@mui/base/TablePagination";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useAppSelector } from "../../../store/hooks";
import MemberServices from "../../../services/MemberServices";
import AlertWithModal from "../../../components/utilityComponents/AlertWithModal";

interface AddFormValue {
  FirmName: string | null;
  Address1: string | null;
  Address2: string | null;
  County: string | null;
  State: string | null;
  Zipcode: string | null;
  City: string | null;
  PhoneNumber: string | null;
  FaxNumber: string | null;
  Email: string | null;
  FirmAdminName: string | null;
  FirmAdminPhoneNumber: string | null;
  FirmAdminEmailId: string | null;
}

interface IConfiguration {
  [key: string]: any;
}

const FirmManagement: React.FC = () => {
  const [FirmList, setFirmList] = useState<any[]>([]);
  const [dialogTitle, setdialogTitle] = useState<string>("Add Firm");

  const [addFirmOpen, setaddFirmOpen] = useState<boolean>(false);
  const [Id, setId] = useState<number>(1);
  const [selectedRow, setSelectedRow] = useState<any | undefined>();
  const [isEdit, setisEdit] = useState<boolean>(false);
  const form = useForm<AddFormValue>();
  const { register, control, handleSubmit, formState, setValue, reset } = form;
  const { errors, touchedFields, dirtyFields } = formState;
  const [CurrentAPICallPage, setCurrentAPICallPage] = useState(1);
  const [FrimPerAPICall, setFrimPerAPICall] = useState(10);
  const [searchInput, setSearchInput] = useState<string>("");
  const [CurrentPage, setCurrentPage] = useState(1);
  const [TotalRecords, setTotalRecords] = useState(0);
  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );
  const [showInputs, setShowInputs] = useState("");

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );

  const getFirmList = async () => {
    let FirmParams = {
      CurrentPage: CurrentAPICallPage,
      Paginate: FrimPerAPICall,
      searchElement: searchInput,
    };
    const response = await AdminUserService.getFirm(FirmParams);
    console.log(response);
    if (response.data.data != null) {
      setFirmList(response.data.data.Firms);
      setTotalRecords(response.data.data.Pagiation[0].TotalRecords);
      console.log(response.data.data.Pagiation);
    } else {
      alert(response.data.errors[0]);
    }
  };
  useEffect(() => {
    getFirmList();
  }, [CurrentAPICallPage, searchInput]);

  useEffect(() => {
    const getConfigurationLists = async () => {
      console.log("getConfigurationLists called");
      const response = await MemberServices.getConfigurationList();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        // console.log("response1...", response.data.data);
        setConfigurationLists(response.data.data);
      } else {
      }
    };
    getConfigurationLists();
  }, []);

  const addFirm = async (data: any) => {
    const response = await AdminUserService.addFirm(data);
    console.log(response);
    if (response.data.data != null) {
      getFirmList();
      setaddFirmOpen(false);
      alert("Firm Added Successfully");
    } else {
      alert(response.data.errors[0]);
    }
  };

  const updateFirm = async (data: any) => {
    const response = await AdminUserService.updateFirm(data);
    console.log(response);
    if (response.data.data != null) {
      getFirmList();
      setaddFirmOpen(false);
      alert("Firm Updated Successfully");
    } else {
      alert(response.data.errors[0]);
    }
  };

  const columns = React.useMemo<Column<any>[]>(
    () => [
      { id: "Id", Header: "ID", accessor: "Id" },
      { id: "FirmName", Header: "Firm Name", accessor: "FirmName" },
      { id: "Address1", Header: "Address1", accessor: "Address1" },
      { id: "Address2", Header: "Address2", accessor: "Address2" },
      { id: "County", Header: "County", accessor: "County" },
      { id: "State", Header: "State", accessor: "State" },
      { id: "City", Header: "City", accessor: "City" },
      {
        id: "edit",
        Header: "Action",
        accessor: (row: any) => (
          <a
            className="d-flex editRow justify-content-center"
            onClick={() => handleEdit(row)}
          >
            <EditIcon></EditIcon>
          </a>
        ),
      },
    ],
    []
  );

  const handleEdit = (rowData: any) => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("settings.edit")
      )
    ) {
      alert("No Access");
      return;
    }
    console.log("Edit clicked for row:", rowData);
    setisEdit(true);
    reset();
    setSelectedRow(rowData);
    setValue("FirmName", rowData.FirmName);
    setValue("Address1", rowData.Address1);
    setValue("County", rowData.County);
    setValue("Zipcode", rowData.Zipcode);
    setValue("City", rowData.City);
    setValue("Address2", rowData.Address2);
    setValue("State", rowData.State);

    setValue("FirmAdminName", rowData.FirmAdminName);
    setValue("FirmAdminPhoneNumber", rowData.FirmAdminPhoneNumber);
    setValue("FirmAdminEmailId", rowData.FirmAdminEmailId);
    setId(rowData.Id);
    setdialogTitle("Update Firm");
    setaddFirmOpen(true);
  };

  const data = useMemo(() => FirmList, [FirmList])!;

  const TableInstance = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    TableInstance;
  let index = 0;

  const onSubmit = (data: AddFormValue) => {
    const FirmName = data.FirmName || "";
    const Address1 = data.Address1 || "";
    const County = data.County || "";
    const Zipcode = data.Zipcode || "";
    const City = data.City || "";
    const Address2 = data.Address2 !== undefined ? data.Address2 : "";
    const State = data.State !== undefined ? data.State : "";

    const FirmAdminName =
      data.FirmAdminName !== undefined ? data.FirmAdminName : "";
    const FirmAdminPhoneNumber =
      data.FirmAdminPhoneNumber !== undefined ? data.FirmAdminPhoneNumber : "";
    const FirmAdminEmailId =
      data.FirmAdminEmailId !== undefined ? data.FirmAdminEmailId : "";
    let id = {
      Id: Id,
    };
    console.log("SUBMIT");
    const formData = {
      FirmName: FirmName,
      Address1: Address1,
      Address2: Address2,
      County: County,
      State: State,
      Zipcode: Zipcode,
      City: City,

      FirmAdminName: FirmAdminName,
      FirmAdminPhoneNumber: FirmAdminPhoneNumber,
      FirmAdminEmailId: FirmAdminEmailId,
    };
    console.log("SUBMIT");
    // console.log(e)
    console.log(data);
    console.log(formData);
    isEdit ? updateFirm({ ...formData, ...id }) : addFirm(formData);
  };

  const openDialog = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("settings.create")
      )
    ) {
      alert("No Access");
      return;
    }

    setValue("FirmName", "");
    setValue("Address1", "");
    setValue("County", "");
    setValue("Zipcode", "");
    setValue("City", "");
    setValue("Address2", "");
    setValue("State", "");

    setValue("FirmAdminName", "");
    setValue("FirmAdminPhoneNumber", "");
    setValue("FirmAdminEmailId", "");
    setdialogTitle("Add Firm");
    setisEdit(false);
    setaddFirmOpen(true);
  };

  const handleChange = (value: number) => {
    setCurrentPage(value);
    setCurrentAPICallPage(value);
    console.log(value, CurrentAPICallPage, CurrentPage);
    // console.log()
    // getFirmList()
  };

  const handleClose = () => {
    reset();
    setaddFirmOpen(false);
  };

  // const handleChangeRowsPerPage = (
  //     event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   ) => {
  //     setFrimPerAPICall(parseInt(event.target.value,5));
  //     setCurrentPage(0);
  //   }

  const handleSearchButtonClick = (e: any) => {
    e.preventDefault();
    setSearchInput(showInputs);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };

  const handleSearchInputChange = (e: any) => {
    setShowInputs(e.target.value);
  };

  const handleClearSearch = () => {
    setShowInputs("");
    setSearchInput("");
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };

  return (
    <div className="container-fluid">
      <div className="dashboard-content-wrapper">
        <div
          className="d-flex justify-content-between w-100"
          style={{ width: "90%" }}
        >
          <h1 className="page-heading">Firm Management</h1>
          <div className="mb-2">
            <form onSubmit={handleSearchButtonClick}>
              <div
                style={{
                  display: "flex",
                  position: "relative",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <input
                  type="text"
                  placeholder="Search"
                  value={showInputs}
                  onChange={handleSearchInputChange}
                  style={{
                    padding: " 5px 0px 5px 40px",
                    backgroundColor: "rgb(250 250 250)",
                    border: "0px",
                    borderBottom: "1px solid #000",
                    width: "450px",
                  }}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 29.999 30"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "1%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <path
                    id="Path_410"
                    data-name="Path 410"
                    d="M97.348,125.943a4.922,4.922,0,0,0,1.211-1.028l7.662-7.662c.161-.161.264-.183.448-.037a11.212,11.212,0,0,0,5.24,2.3,11.863,11.863,0,1,0-5.534-20.866,11.78,11.78,0,0,0-3.75,5.439,11.86,11.86,0,0,0,1.864,10.958c.139.183.139.279-.029.448q-3.974,3.952-7.934,7.927a2.909,2.909,0,0,0-.756,1.005v.587a1.623,1.623,0,0,0,1,.939C96.959,125.943,97.157,125.943,97.348,125.943Zm16.558-8.749a9.369,9.369,0,1,1,9.343-9.409A9.372,9.372,0,0,1,113.906,117.194Z"
                    transform="translate(-95.77 -95.95)"
                    fill="currentColor"
                  ></path>
                </svg>
                <button
                  className="btn"
                  type="submit"
                  // onClick={handleSearchButtonClick}
                  style={{
                    marginLeft: "8px",
                    background: "#366287",
                    color: "#FFFFFF",
                  }}
                >
                  Search
                </button>
                <button
                  className="btn"
                  onClick={handleClearSearch}
                  style={{
                    marginLeft: "8px",
                    background: "#757575",
                    color: "#FFFFFF",
                  }}
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
          <div className="settings-add-button ms-4">
            <div className="secondary-button" onClick={() => openDialog()}>
              <AddCircleOutlineIcon></AddCircleOutlineIcon>
              <span className="ps-1">Add Firm</span>
            </div>
            {/* <ButtonWithIcon
                            icon={<></>}
                            buttontext="Add Firm"
                            onClick={() => openDialog()}
                        /> */}
          </div>
        </div>
        <div className="firm-table">
          <table {...getTableProps}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps} key={index++}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} key={column.id}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={row.index}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}> {cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* <Pagination count={TotalRecords} page={CurrentPage} onChange={handleChange} variant="outlined" shape="rounded" boundaryCount={2} /> */}
        {/* <TablePagination
                    count={TotalRecords}
                    page={CurrentPage}
                    onPageChange={handleChange}
                    rowsPerPage={FrimPerAPICall}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
        {/* Pagenation-start */}
        <div
          className="horizontal-wrapper-centeraligned"
          style={{ marginTop: "10px" }}
        >
          <div
            className="round-button-div"
            style={{ width: "30px", height: "30px", marginRight: "10px" }}
          >
            <RoundButtonWithIcon
              icon={<LeftArrowIcon height={15} width={8} />}
              onClick={() => handleChange(CurrentPage - 1)}
              disabled={CurrentPage === 1}
            />
          </div>

          {FirmList.length > 1 ? (
            <div className="heading_medium">
              {" "}
              <span style={{ fontWeight: "500" }}>
                {1 + (CurrentPage - 1) * FrimPerAPICall}{" "}
              </span>{" "}
              -{" "}
              <span style={{ fontWeight: "500" }}>
                {FirmList.length + (CurrentPage - 1) * FrimPerAPICall}{" "}
              </span>
              of <span style={{ fontWeight: "500" }}>{TotalRecords} </span>{" "}
              Firms
            </div>
          ) : (
            <div>
              <div className="heading_medium">
                <span style={{ fontWeight: "500" }}>{TotalRecords} </span>{" "}
                members
              </div>
            </div>
          )}
          <div
            style={{
              height: "30px",
              width: "30px",
              transform: "rotate(180deg)",
              marginLeft: "10px",
            }}
          >
            {" "}
            <RoundButtonWithIcon
              icon={<LeftArrowIcon height={15} width={8} />}
              onClick={() => handleChange(CurrentPage + 1)}
              disabled={
                CurrentPage === Math.ceil(TotalRecords / FrimPerAPICall)
              }
            />{" "}
          </div>
        </div>
        {/* Pagenation-end */}
      </div>
      <ReactModal
        isOpen={addFirmOpen}
        // className="addtype-modal"
        className="editinfo-modal-large"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "1rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            {dialogTitle}
          </h1>
          <PageLink
            onClick={() => handleClose()}
            style={{ marginBottom: "1rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex">
            <div className="input-field-div-wrapper w-100">
              <Label>Firm Name</Label>
              <input
                className="input-field-div"
                placeholder="Firm Name"
                {...register("FirmName", { required: "Firm Name is required" })}
                name="FirmName"
                id="FirmName"
                autoComplete="off"
              />
              <p className="form-error form-error-position">
                {errors.FirmName?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper w-100 mx-3">
              <Label>Address 1</Label>
              <input
                className="input-field-div"
                placeholder="Address 1"
                {...register("Address1", { required: "Address1 is required" })}
                name="Address1"
                id="Address1"
                autoComplete="off"
              />
              <p className="form-error form-error-position">
                {errors.Address1?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper w-100">
              <Label>Address 2</Label>
              <input
                className="input-field-div"
                placeholder="Address 2"
                {...register("Address2", { required: false })}
                name="Address2"
                id="Address2"
                autoComplete="off"
              />
            </div>
          </div>
          <div className="d-flex">
            <div className="input-field-div-wrapper w-100">
              <Label>City</Label>
              <input
                className="input-field-div"
                placeholder="City"
                {...register("City", { required: "City is required" })}
                name="City"
                id="City"
                autoComplete="off"
              />
              <p className="form-error form-error-position">
                {errors.City?.message}
              </p>
            </div>

            {/* <div className="input-field-div-wrapper w-100 mx-3">
              <Label>State</Label>
              <input
                className="input-field-div"
                placeholder="State"
                {...register("State", { required: false })}
                name="State"
                id="State"
                autoComplete="off"
              />
            </div> */}

            <div className="input-field-div-wrapper w-100 mx-3">
              <div className="selectfield-label">State</div>
              <select
                className="dropdown-control-large-insidetextfield"
                {...register(
                  "State",
                  // {
                  //   required: "State is a required field"
                  // }
                  { required: false }
                )}
                autoComplete="off"
              >
                <option value={""}> Select State </option>
                {configurationList.StateList?.map((State: any) => (
                  <option key={State.Id} value={State.StateName}>
                    {State.StateName}
                  </option>
                ))}
                ;
              </select>
              <p className="form-error form-error-position">
                {errors.State?.message}
              </p>
            </div>

            <div className="input-field-div-wrapper w-100">
              <Label>Zip Code</Label>
              <input
                className="input-field-div"
                placeholder="Zip Code"
                {...register(
                  "Zipcode",
                  // { required: "Zip Code is required" }
                  { required: false }
                )}
                name="Zipcode"
                id="Zipcode"
                autoComplete="off"
              />
              <p className="form-error form-error-position">
                {errors.Zipcode?.message}
              </p>
            </div>
          </div>

          <div className="d-flex">
            <div className="input-field-div-wrapper w-100">
              {/* <Label>County</Label> */}
              <select
                className="dropdown-control-large-insidetextfield"
                id="County"
                {...register("County", { required: false })}
              >
                <option value={""}> Select County </option>
                <option value="NEW CASTLE">NEW CASTLE</option>
                <option value="KENT">KENT</option>
                <option value="SUSSEX">SUSSEX</option>
                <option value="OUT OF STATE">OUT OF STATE</option>
              </select>
            </div>
            <div className="input-field-div-wrapper w-100 mx-3">
              <Label>Firm Admin Name</Label>
              <input
                className="input-field-div"
                placeholder="Firm Admin Name"
                {...register("FirmAdminName", { required: false })}
                name="FirmAdminName"
                id="FirmAdminName"
                autoComplete="off"
              />
            </div>
            <div className="input-field-div-wrapper w-100">
              <Label>Firm Admin Phone Number</Label>
              <input
                className="input-field-div"
                placeholder="Firm Admin Phone Number"
                {...register("FirmAdminPhoneNumber", {
                  required: false,
                  pattern: {
                    value: /^\d{10}$/,
                    message: "Please enter a valid 10-digit phone number",
                  },
                })}
                name="FirmAdminPhoneNumber"
                id="FirmAdminPhoneNumber"
                autoComplete="off"
              />
              <p className="form-error form-error-position">
                {errors.FirmAdminPhoneNumber &&
                  errors.FirmAdminPhoneNumber.message}
              </p>
            </div>
          </div>

          <div className="d-flex">
            <div className="input-field-div-wrapper w-auto">
              <Label>Firm Admin Email ID</Label>
              <input
                className="input-field-div"
                placeholder="Firm Admin Email ID"
                {...register("FirmAdminEmailId", {
                  required: false,
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email address",
                  },
                })}
                name="FirmAdminEmailId"
                id="FirmAdminEmailId"
                autoComplete="off"
              />
              <p className="form-error form-error-position">
                {errors.FirmAdminEmailId && errors.FirmAdminEmailId.message}
              </p>
            </div>
          </div>
          <div className="w-100 d-flex justify-content-center">
            <div className="submit-button-div">
              <Button type="submit">{isEdit ? "Update" : "Add"}</Button>
            </div>
          </div>
        </form>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default FirmManagement;
